import { render, staticRenderFns } from "./QuestionnaireEditor.vue?vue&type=template&id=4f5359b0&scoped=true&"
import script from "./QuestionnaireEditor.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireEditor.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireEditor.vue?vue&type=style&index=0&id=4f5359b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5359b0",
  null
  
)

export default component.exports